module.exports = __webpack_public_path__ + "static/media/cerio.89484554.png";